function handleStickyScroll() {
	const $el = $('.block__weeks.sticky');
	const scrollTop = $(window).scrollTop();
	const viewportHeight = $(window).height();


	const threshold = window.innerWidth <= 768 ? 120 : 140;

	if (scrollTop > threshold) {
		$el.addClass('is-sticky fixed-sticky');
	} else {
		$el.removeClass('is-sticky fixed-sticky');
	}


	$('.block__weeks.sticky-mobile').removeClass('is-sticky');
}

$(window).on('scroll resize', handleStickyScroll);
handleStickyScroll();